(function() {
    'use strict';
    angular.module('wbUtilities').factory('Log', [function () {
        var log = {};

        log.send = function (title, description, data) {
            //SEND DATA TO SOME LOGGING SERVICE
            //FOR DEBUGGING/DEVELOPMENT USE
            return true;
        };
        
        return log;
    }]);
})();
